<template>
  <vs-popup class="customer-sample-order-create-popup"
            id="popup"
            title="SAMPLE ORDER DOCUMENT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <vx-row>
        <vx-col>
          <div class="flex">
            <div class="flex">
              <vs-button class=""  @click="onClickPrint()" color="warning" type="border" >Print</vs-button>
              <vs-button   class="ml-2" color="dark" type="border" >Download</vs-button>
            </div>
          </div>
        </vx-col>
      </vx-row>

      <div id="printDiv">

        <div class="vx-row md:mb-3 mt-8">
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                              <span class="text-md">
                                  <h5 class="mb-2">Customer</h5>
                                  {{ orderDetails.customer.company_name }}
                              </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="DollarSignIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                              <span class="text-md break-all">
                                  <h5 class="mb-2">Account Number</h5>
                                  {{ orderDetails.customer.account_number }}
                              </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                              <span class="text-md break-all">
                                  <h5 class="mb-2">Order Date</h5>
                                  {{ __dateTimeFormatter(orderDetails.created_at) }}
                              </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="RefreshCwIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                              <span class="text-md break-all">
                                  <h5 class="mb-2">Order Status</h5>
                                  <vs-chip style="border-radius: 0" class="text-center" transparent
                                           :color="sampleOrderStatusColorFactory()">
                                      {{ orderDetails.status.name }}
                                  </vs-chip>
                              </span>
              </vs-col>
            </vs-row>
          </div>
        </div>

        <div class="vx-row md:mb-3 mt-16">
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="MapPinIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                              <span class="text-md">
                                  <h5 class="mb-2">Address</h5>
                                  {{ orderDetails.line1 }} <br v-if="orderDetails.line1">
                                  {{ orderDetails.line2 }} <br v-if="orderDetails.line2">
                                  {{ orderDetails.line3 }} <br v-if="orderDetails.line3">
                                  {{ orderDetails.town_state }} <br>
                                  {{ orderDetails.post_code }} <br>
                                  {{ orderDetails.country }} <br>
                              </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="TruckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                              <span class="text-md break-all">
                                  <h5 class="mb-2">Delivery Instructions</h5>
                                  {{ orderDetails.delivery_instruction || 'N/A' }}
                              </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/4 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                              <span class="text-md break-all">
                                  <h5 class="mb-2">Notes</h5>
                                  {{ orderDetails.notes || 'N/A' }}
                              </span>
              </vs-col>
            </vs-row>
          </div>
        </div>

        <div class="vx-row my-8">
          <div class="vx-col w-full">

            <vs-table :data="sample_items" stripe>
              <template slot="thead">
                <vs-th width="20%">FORMULATION CODE</vs-th>
                <vs-th width="40%">FORMULATION NAME</vs-th>
                <vs-th width="20%">QUANTITY (GRAMS)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :ref="`table_row_${indextr}`" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td colspan="3" v-if="tr.type === 'sub'">

                    <vs-table class="mx-16 my-8" :data="tr.rm_items">

                      <template slot="header">
                        <h5 class="mb-4">Formulations breakdown</h5>
                      </template>

                      <template slot="thead">
                        <vs-th width="10%">PRODUCT CODE</vs-th>
                        <vs-th width="15%">PRODUCT NAME</vs-th>
                        <vs-th width="10%">QUANTITY (GRAMS)</vs-th>
                        <vs-th width="5%">SOL</vs-th>
                        <vs-th width="5%">HALAL</vs-th>
                        <vs-th width="10%">KOSHER</vs-th>
                      </template>

                      <template slot-scope="{data}">
                        <vs-tr :key="index_rm_item" v-for="(tr_item, index_rm_item) in data">

                          <vs-td>
                            <span v-if="tr_item.company_product_code"> {{ tr_item.category }}-{{ tr_item.company_product_code }} </span>
                            <span v-if="tr_item.formulation_code"> {{ tr_item.formulation_code }} </span>
                          </vs-td>

                          <vs-td :data="tr_item.company_product_name">
                            {{ tr_item.company_product_name || '' }}
                          </vs-td>

                          <vs-td :data="tr_item.quantity_kg">
                            {{ Number(tr_item.quantity_kg).toFixed(1) }}
                          </vs-td>

                          <vs-td :data="tr_item.dissolvable">
                            {{ tr_item.dissolvable === 'Yes' ? 'S' : '' }}
                          </vs-td>

                          <vs-td :data="tr_item.halal_suitable">
                            {{ suitableOrCertified(tr_item.halal_suitable, tr_item.halal_certified) }}
                          </vs-td>

                          <vs-td :data="tr_item.kosher_suitable">
                            {{ suitableOrCertified(tr_item.kosher_suitable, tr_item.kosher_certified) }}
                          </vs-td>

                        </vs-tr>
                      </template>

                    </vs-table>

                  </vs-td>

                  <vs-td v-if="tr.type === 'main'" :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code }}
                  </vs-td>

                  <vs-td v-if="tr.type === 'main'" :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td v-if="tr.type === 'main'" :data="data[indextr].quantity">
                    {{ data[indextr].quantity }}
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

      </div>



    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const CustomerRepository = RepositoryFactory.get('customer')
const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
const FormulationsRepository = RepositoryFactory.get('formulations');

import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import {Printd} from "printd";
import $ from 'jquery'

function initialState() {
  return {
    open: false,
    id: '',
    orderDetails: {},
    customerId: '',
    createForm: {},
    countryCodes: [],
    customerUsers: [],
    isCreateFromMainMenu: false,
    customers: [],
    formulations: [],
    addresses: [],
    selectedAddress: {},
    sample_items: []
  }
}

export default {
  name: 'GeneratePdfSampleOrderPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(orderDetails) {
      try {
        Object.assign(this.$data, initialState())
        Object.assign(this.orderDetails, orderDetails)
        this.sample_items = []
        this.orderDetails.formulation_items.forEach((x) => {
          const rm_items = x.raw_material_items
          this.sample_items.push({ type: 'main', id: x.id,  formulation_code: x.formulation_code, name: x.name, quantity: x.quantity })
          this.sample_items.push({ type: 'sub', rm_items: rm_items })
        })
        this.open = true;
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async onClickCreateSampleOrder() {
      const vue = this;
      this.$vs.loading()
      try {
        const payload = {
          line1: this.createForm.line1,
          line2: this.createForm.line2,
          line3: this.createForm.line3,
          town_state: this.createForm.town_state,
          post_code: this.createForm.post_code,
          country: this.createForm.country,
          delivery_instruction: this.createForm.delivery_instruction,
          notes: this.createForm.notes,
        }
        await CustomerRepository.updateCustomerSampleOrder(this.id, payload)
        this.showSuccessMessage('Sample order update successfully')
        await vue.$parent.refreshData()
        this.open = false;
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async getFormulations() {
      this.$vs.loading()
      const {data} = await FormulationsRepository.get(1, '', 50, '')
      this.formulations = data.data
      this.$vs.loading.close()
    },
    async getSampleOrder() {
      this.$vs.loading()
      const {data} = await CustomerRepository.getCustomerSampleOrder(this.id)
      this.createForm = data.data
      this.$vs.loading.close()
    },
    async getCountryCodes() {
      this.$vs.loading()
      this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
      this.$vs.loading.close()
    },
    async getAddresses() {
      this.$vs.loading()
      this.addresses = (await CustomerRepository.getSampleDeliveryAddresses(this.customerId)).data.data;
      this.$vs.loading.close()
    },
    onChangeSelectDeliveryAddress(selected) {
      this.createForm.line1 = selected.line1
      this.createForm.line2 = selected.line2
      this.createForm.line3 = selected.line3
      this.createForm.town_state = selected.town_state
      this.createForm.post_code = selected.post_code
      this.createForm.country = selected.country
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    doCheckItems(data) {

    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce(async (loading, search, vm) => {
      const {data} = await CustomerRepository.getSampleList(null, 1, `filter[search]=${search}`, 50, '')
      vm.formulations = data.data
      loading(false);
    }, 350),

    sampleOrderStatusColorFactory() {
      const colors = {
        1: '#f8961e',
        2: '#f9844a',
        3: '#f9c74f',
        4: '#43aa8b',
        5: '#219ebc',
        6: '#006d77',
        7: '#d62828',
        8: '#4895ef',
        9: '#3a0ca3',
        10: '#52b788',
        11: '#f72585'
      }
      return colors[this.orderDetails.status.id]
    },
    suitableOrCertified(suitable, certified) {
      let text = ''
      if (suitable === 'Yes') {
        text = text + ' S'
      }
      if (certified === 'Yes') {
        text = text + ' C'
      }
      return text
    },
    // onClickPrint() {
    //   let printContents = document.getElementById('printDiv').innerHTML;
    //   let originalContents = document.body.innerHTML;
    //   document.body.innerHTML = printContents;
    //   window.print();
    //   document.body.innerHTML = originalContents;
    // },
    onClickPrint() {
      const d = new Printd()
      const styles = ``
      d.print(document.getElementById('printDiv'))
    },
  },
  async mounted() {

  },
  computed: {},
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.customer-sample-order-create-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}
@media screen {
  #printSection {
    display: none;
  }
}

@media print {
  body * {
    visibility:hidden;
    width: 100%;
  }
  #printSection, #printSection * {
    visibility:visible;
  }
  #printSection {
    position:absolute;
    left:0;
    top:0;
  }
  svg{
    margin-top: 10px;
    margin-left:10px!important; ;
  }
}

</style>
